/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import {
  FETCHING_SUBJECT_PHI_INFORMATION,
  FETCHED_SUBJECT_PHI_INFORMATION,
  FETCH_SUBJECT_PHI_INFORMATION_ERROR,
  PUBLISH_PHI_STUDY_GID_AND_PARTICIPANT_ID,
  FETCHED_STUDY_INFORMATION,
  FETCH_STUDY_INFORMATION_ERROR,
  FETCHING_STUDY_INFORMATION,
  FETCHED_SITE_INFORMATION,
  FETCHING_SITE_INFORMATION,
  FETCH_SITE_INFORMATION_ERROR,
  UPDATED_PARTICIPANT_JOURNEY,
  UPDATE_PARTICIPANT_JOURNEY_ERROR,
  CLEAR_UPDATE_ERROR,
  FETCHED_PARTICIPANT_JOURNEY,
  FETCHING_PARTICIPANT_JOURNEY,
  FETCH_PARTICIPANT_JOURNEY_ERROR,
  FETCHED_AVAILABLE_DOCUMENTS,
  FETCHING_AVAILABLE_DOCUMENTS,
  FETCH_AVAILABLE_DOCUMENTS_ERROR,
  ASSIGN_PARTICIPANT_DOCUMENT_ERROR,
  FETCHED_PRODUCTION_TENANT_FOR_UAT,
  FETCHING_PRODUCTION_TENANT_FOR_UAT_ERROR,
  FETCHING_PRODUCTION_TENANT_FOR_UAT,
  UPDATED_PARTICIPANT_EMAIL,
  UPDATE_PARTICIPANT_EMAIL_ERROR,
  CLEAR_UPDATE_PARTICIPANT_EMAIL_ERROR,
  UPDATE_PARTICIPANT_EMAIL_LOADING,
  UPDATED_PARTICIPANT_GENDER,
  UPDATE_PARTICIPANT_GENDER_ERROR,
  CLEAR_UPDATE_PARTICIPANT_GENDER_ERROR,
  UPDATE_PARTICIPANT_GENDER_LOADING,
  UPDATED_PARTICIPANT_BIRTHDATE,
  UPDATE_PARTICIPANT_BIRTHDATE_ERROR,
  UPDATE_PARTICIPANT_BIRTHDATE_LOADING,
  UPDATED_PARTICIPANT_ADDRESS,
  UPDATE_PARTICIPANT_ADDRESS_ERROR,
  UPDATE_PARTICIPANT_ADDRESS_LOADING,
  FETCHED_CONSENTING,
  FETCH_CONSENTING_ERROR,
  FETCHING_CONSENTING
} from '../actions/actionTypes';
import cloneDeep from 'lodash/cloneDeep';

const initialSubjectState = {
  participantJourney: null,
  participantStudy: null,
  participantSites: null,
  isFetchingStudy: null,
  isFetchingSites: null,
  isFetchingJourney: false,
  error: null,
  isFetchingAvailableDocuments: false,
  availableDocuments: null,
  availableDocumentsError: null,
  phi: {
    studyGid: null,
    participantId: null,
    isFetching: true,
    subjectInfo: null,
    error: null
  },
  errorUpdateJourney: null,
  productionTenantForUAT: null,
  errorUpdateParticipantEmail: null,
  isLoadingParticipantEmail: false,
  errorUpdateParticipantGender: null,
  isLoadingParticipantGender: false,
  errorUpdateParticipantBirthdate: null,
  isLoadingParticipantBirthdate: false,
  errorUpdateParticipantAddress: null,
  isLoadingParticipantAddress: false
};

const updatePhi = (statePhi, payload) => {
  let phi = cloneDeep(statePhi);
  const { gender, birthDate, addressCity, addressPostalCode, addressStreet } = payload;
  if (gender) {
    phi.subjectInfo.data.participant.gender = gender;
  }
  if (birthDate) {
    phi.subjectInfo.data.participant.birthDate = birthDate;
  }
  if (addressCity) {
    phi.subjectInfo.data.participant.addressCity = addressCity;
  }
  if (addressPostalCode) {
    phi.subjectInfo.data.participant.addressPostalCode = addressPostalCode;
  }
  if (addressStreet) {
    phi.subjectInfo.data.participant.addressStreet = addressStreet;
  }
  return phi;
};

const subjectReducer = (state = initialSubjectState, action) => {
  switch (action.type) {
    case FETCHED_STUDY_INFORMATION:
      return Object.assign({}, state, {
        participantStudy: action.payload.participantStudy,
        isFetchingStudy: false,
        error: null
      });
    case FETCH_STUDY_INFORMATION_ERROR:
      return Object.assign({}, state, { error: action.payload, isFetchingStudy: false });
    case FETCHING_STUDY_INFORMATION:
      return Object.assign({}, state, { isFetchingStudy: true });
    case PUBLISH_PHI_STUDY_GID_AND_PARTICIPANT_ID:
      return Object.assign({}, state, {
        phi: Object.assign({}, state.phi, {
          studyGid: action.payload.studyGid,
          participantId: action.payload.participantId
        })
      });
    case FETCHING_SUBJECT_PHI_INFORMATION:
      return Object.assign({}, state, {
        phi: Object.assign({}, state.phi, { isFetching: true, subjectInfo: null, error: null })
      });
    case FETCHED_SUBJECT_PHI_INFORMATION:
      return Object.assign({}, state, {
        phi: Object.assign({}, state.phi, { subjectInfo: action.payload, isFetching: false, error: null })
      });
    case FETCH_SUBJECT_PHI_INFORMATION_ERROR:
      return Object.assign({}, state, {
        phi: Object.assign({}, state.phi, { error: action.payload, isFetching: false, subjectInfo: null })
      });
    case FETCHED_SITE_INFORMATION:
      return Object.assign({}, state, { participantSites: action.payload.participantSites, isFetchingSites: false });
    case FETCHING_SITE_INFORMATION:
      return Object.assign({}, state, { participantSites: action.payload.participantSites, isFetchingSites: false });
    case FETCH_SITE_INFORMATION_ERROR:
      return Object.assign({}, state, { isFetchingSites: false, error: action.payload });
    case UPDATED_PARTICIPANT_JOURNEY:
      return Object.assign({}, state, {
        isFetchingJourney: false,
        participantJourney: action.payload.data,
        errorUpdateJourney: null
      });
    case UPDATE_PARTICIPANT_JOURNEY_ERROR:
      return Object.assign({}, state, { isFetchingJourney: false, errorUpdateJourney: action.payload });
    case FETCHING_PARTICIPANT_JOURNEY:
      return Object.assign({}, state, { isFetchingJourney: true });
    case FETCHED_PARTICIPANT_JOURNEY:
      return Object.assign({}, state, {
        participantJourney: action.payload.data,
        isFetchingJourney: false,
        errorUpdateJourney: null
      });
    case FETCH_PARTICIPANT_JOURNEY_ERROR:
      return Object.assign({}, state, {
        isFetchingJourney: false,
        errorUpdateJourney: action.payload,
        participantJourney: null
      });
    case CLEAR_UPDATE_ERROR:
      return Object.assign({}, state, { errorUpdateJourney: null });
    case FETCHED_AVAILABLE_DOCUMENTS:
      return Object.assign({}, state, {
        availableDocuments: action.payload,
        availableDocumentsError: null,
        isFetchingAvailableDocuments: false
      });
    case FETCHING_AVAILABLE_DOCUMENTS:
      return Object.assign({}, state, {
        availableDocuments: null,
        availableDocumentsError: null,
        isFetchingAvailableDocuments: true
      });
    case FETCH_AVAILABLE_DOCUMENTS_ERROR:
      return Object.assign({}, state, {
        availableDocuments: null,
        availableDocumentsError: action.payload,
        isFetchingAvailableDocuments: false
      });
    case ASSIGN_PARTICIPANT_DOCUMENT_ERROR:
      return Object.assign({}, state, { availableDocumentsError: action.payload });
    case FETCHING_PRODUCTION_TENANT_FOR_UAT:
      return Object.assign({}, state, { isFetchingStudy: true, productionTenantForUAT: null });
    case FETCHED_PRODUCTION_TENANT_FOR_UAT:
      return Object.assign({}, state, { isFetchingStudy: false, productionTenantForUAT: action.payload });
    case FETCHING_PRODUCTION_TENANT_FOR_UAT_ERROR:
      return Object.assign({}, state, { isFetchingStudy: false, error: action.payload, productionTenantForUAT: null });
    case UPDATED_PARTICIPANT_EMAIL:
      return Object.assign({}, state, {
        isFetchingJourney: false,
        participantJourney: action.payload.data,
        errorUpdateParticipantEmail: null,
        isLoadingParticipantEmail: false
      });
    case UPDATE_PARTICIPANT_EMAIL_ERROR:
      return Object.assign({}, state, {
        isFetchingJourney: false,
        errorUpdateParticipantEmail: action.payload,
        isLoadingParticipantEmail: false
      });
    case CLEAR_UPDATE_PARTICIPANT_EMAIL_ERROR:
      return Object.assign({}, state, { errorUpdateParticipantEmail: null, isLoadingParticipantEmail: false });
    case UPDATE_PARTICIPANT_EMAIL_LOADING:
      return Object.assign({}, state, { isLoadingParticipantEmail: true });
    case UPDATED_PARTICIPANT_GENDER:
      return Object.assign({}, state, {
        phi: updatePhi(state.phi, action.payload),
        errorUpdateParticipantGender: null,
        isLoadingParticipantGender: false
      });
    case UPDATE_PARTICIPANT_GENDER_ERROR:
      return Object.assign({}, state, {
        errorUpdateParticipantGender: action.payload,
        isLoadingParticipantGender: false
      });
    case CLEAR_UPDATE_PARTICIPANT_GENDER_ERROR:
      return Object.assign({}, state, { errorUpdateParticipantGender: null, isLoadingParticipantGender: false });
    case UPDATE_PARTICIPANT_GENDER_LOADING:
      return Object.assign({}, state, { isLoadingParticipantGender: true });
    case UPDATED_PARTICIPANT_BIRTHDATE:
      return Object.assign({}, state, {
        phi: updatePhi(state.phi, action.payload),
        errorUpdateParticipantBirthdate: null,
        isLoadingParticipantBirthdate: false
      });
    case UPDATE_PARTICIPANT_BIRTHDATE_ERROR:
      return Object.assign({}, state, {
        errorUpdateParticipantBirthdate: action.payload,
        isLoadingParticipantBirthdate: false
      });
    case UPDATE_PARTICIPANT_BIRTHDATE_LOADING:
      return Object.assign({}, state, { isLoadingParticipantBirthdate: true });
    case UPDATED_PARTICIPANT_ADDRESS:
      return Object.assign({}, state, {
        phi: updatePhi(state.phi, action.payload),
        errorUpdateParticipantAddress: null,
        isLoadingParticipantAddress: false
      });
    case UPDATE_PARTICIPANT_ADDRESS_ERROR:
      return Object.assign({}, state, {
        errorUpdateParticipantAddress: action.payload,
        isLoadingParticipantAddress: false
      });
    case UPDATE_PARTICIPANT_ADDRESS_LOADING:
      return Object.assign({}, state, { isLoadingParticipantAddress: true });
    case FETCHING_CONSENTING:
      return Object.assign({}, state, { consenting: null, errorFetchConsenting: null, isFetchingConsenting: true });
    case FETCHED_CONSENTING:
      return Object.assign({}, state, {
        consenting: action.payload,
        errorFetchConsenting: null,
        isFetchingConsenting: false
      });
    case FETCH_CONSENTING_ERROR:
      return Object.assign({}, state, {
        consenting: null,
        errorFetchConsenting: action.payload,
        isFetchingConsenting: false
      });
    default:
      return state;
  }
};

export default subjectReducer;
